<template>
  <div>
    <van-tabbar v-model="active" fixed>
      <van-tabbar-item v-for="item in tabbars" :key="item.name" :name="item.name" replace :to="item.toUrl">
        <span>{{item.title}}</span>
        <template slot="icon" slot-scope="props">
          <img :src="props.active ? item.active : item.normal">
        </template>
      </van-tabbar-item>
     
    </van-tabbar>
  </div>
</template>

<script>
  export default {
    name: 'FooterBar',
    data() {
      return {
        active: 'home',
        tabbars: []
      }
    },
    props: {
      //传递指定的路由
      activeTab: {
        type: String,
        default: ""
      }
    },
    computed: {},
    methods: {

    },
    mounted: function() {
      let that = this
      // 获得对应的底部菜单数组
      that.tabbars = that.$utils.clone(this.$store.state.roleMenuList)
      console.log(that.tabbars)
      //取消路由模式，根据当前路由判断
      let routename = that.$route.path;
      let filterRoute = that.tabbars.filter(function(m) {
        return m.toUrl == routename
      });
      if (filterRoute.length > 0) {
        that.active = filterRoute[0].name
      } else {
        //根据指定的路由，确定选中的tab
        if (that.activeTab) {
          that.active = that.activeTab
        }
      }

    }
  }
</script>

<style scoped>
  .van-tabbar-item__icon img {
    height: 24px;
  }

  .van-tabbar {
    background-color: #ffffff;
  }
</style>
